import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'title'
	| 'sidebarTitle'
	| 'description'
	| 'sidebarDescription'
	| 'addLinksCta'
	| 'dismissLabel'
	| 'dismissButtonLabel';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		title: {
			id: 'ai-mate.rovo-spaces.smart-context-links-banner.title',
			defaultMessage: 'Bring your sources into this space',
			description:
				'Title of a recommendation banner shown on the Rovo Space landing page that prompts the user to add recommended sources into the current space.',
		},
		sidebarTitle: {
			id: 'ai-mate.rovo-spaces.smart-context-links-banner.sidebarTitle',
			defaultMessage: 'Keep your sources in one place',
			description:
				'Title of the sources recommendation banner when rendered in the narrow Rovo sidebar.',
		},
		description: {
			id: 'ai-mate.rovo-spaces.smart-context-links-banner.description',
			defaultMessage:
				'{count, plural, one {We found # source from your previous chats. Add it here so your team can easily find and reuse it.} other {We found # sources from your previous chats. Add them here so your team can easily find and reuse them.}}',
			description:
				'Subtitle of the sources recommendation banner. {count} is the number of recommended sources found.',
		},
		sidebarDescription: {
			id: 'ai-mate.rovo-spaces.smart-context-links-banner.sidebarDescription',
			defaultMessage:
				'Bring together the sources used in this space to help your team work faster and stay on the same page.',
			description:
				'Subtitle of the sources recommendation banner when rendered in the narrow Rovo sidebar.',
		},
		addLinksCta: {
			id: 'ai-mate.rovo-spaces.smart-context-links-banner.addLinksCta',
			defaultMessage: 'Add sources',
			description:
				'Primary CTA on the sources recommendation banner. Opens a picker for the user to add recommended sources to the space.',
		},
		dismissLabel: {
			id: 'ai-mate.rovo-spaces.smart-context-links-banner.dismissLabel',
			defaultMessage: 'Dismiss sources recommendation',
			description:
				'Accessible label for the dismiss (×) icon button on the sources recommendation banner.',
		},
		dismissButtonLabel: {
			id: 'ai-mate.rovo-spaces.smart-context-links-banner.dismissButtonLabel',
			defaultMessage: 'Dismiss',
			description:
				'Visible text on the full-width dismiss button shown on the narrow Rovo sidebar sources recommendation banner.',
		},
	});

export default messages;
